import { styled, Box, BoxProps } from '@mui/material'
import { ComponentType } from 'react'

export const LoadingContainer: ComponentType<BoxProps> = styled( Box )( {
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	height: '100%',
} )
